<template>
	<div>
		<h1>Results</h1>
		<!-- <div v-if="($tera.project.metaReplicant && $tera.project.metaReplicant.file)"> -->
		<div
			v-if="
				($tera.project.writeStudyCharacteristicsOnResultsSection &&
					$tera.project.detableStudyCharacteristics.headers.length > 0) ||
					($tera.project.metaResult && $tera.project.metaResult.userChange)
			"
		>
			<div style="float: right;">
				<i
					v-if="$tera.project.metaResult.locked"
					class="pi pi-check"
					style="margin-right: 0.5rem;margin-bottom: 0.6rem;color: green;font-weight: 700;"
					aria-hidden="true"
				>
				</i>
				<span
					v-if="$tera.project.metaResult.locked"
					style="margin-right: 1rem;margin-bottom: 0.6rem;color: green;font-weight: 700;"
				>
					Locked
				</span>
				<Button
					:label="$tera.project.metaResult.locked ? 'Unlock' : 'Lock'"
					:icon="
						$tera.project.metaResult.locked ? 'pi pi-lock-open' : 'pi pi-lock'
					"
					class="p-button-info"
					@click="onLockChange()"
				/>
			</div>

			<InputEditorMultiline
				question="result"
				:placeholder="placeholder"
				v-model="$tera.project.metaResult.userChange"
			/>
		</div>
		<div
			v-if="
				$tera.project.metaResult &&
					$tera.project.metaResult.userChange == '' &&
					(!$tera.project.writeStudyCharacteristicsOnResultsSection ||
						($tera.project.writeStudyCharacteristicsOnResultsSection &&
							$tera.project.detableStudyCharacteristics.headers.length == 0))
			"
		>
			<p>
				Write results by uploading meta-analysis JSON file to the replicant.
			</p>
			<div style="margin-top: 5px;">
				<a href="https://tera-tools.com/replicant" target="_blank"
					>Link to Replicant</a
				>
			</div>
			<p>Also write results by entering data into the data extraction form.</p>
			<div style="margin-top: 5px;">
				<a href="#/forms/deStudyChar-view" target="_blank"
					>Link to Study Characeristics</a
				>
			</div>
		</div>
		<!-- <button @click="refresh">Click Here</button> -->
		<!-- PrimeVue Dialog -->
		<Dialog
			:visible="confirmDialogVisible"
			modal
			header="Caution"
			:style="{ width: '32rem' }"
		>
			<div class="flex">
				<Button
					icon="pi pi-exclamation-triangle"
					class="p-button-danger btnStyles"
				/>
				<span
					icon="pi pi-exclamation-triangle"
					class="text-surface-500 dark:text-surface-400 block mb-8"
					>This will override your changes. Do you wish to proceed?</span
				>
			</div>
			<div class="divStyle">
				<Button
					type="button"
					label="Cancel"
					class="p-button-info"
					@click="confirmDialogVisible = false"
				></Button>
				<Button
					type="button"
					label="Yes, Proceed"
					class="p-button-danger"
					@click="lockChangeConfirmed()"
				></Button>
			</div>
		</Dialog>
	</div>
</template>

<script>
import InputEditorMultiline from "@/components/InputEditorMultiline.vue";
import translations from "@/lang/en.json";
import Button from "primevue/button";
import Dialog from "primevue/dialog";

export default {
	components: {
		InputEditorMultiline,
		Button,
		Dialog
	},
	data() {
		return {
			placeholder: "Replicant Results",
			translations,
			confirmDialogVisible: false,
			regeneratedValue: ""
		};
	},
	mounted() {
		if (
			this.$tera.project.metaResult.locked == false ||
			(this.$tera.project.metaResult.locked &&
				this.$tera.project.metaResult.userChange == "")
		) {
			this.$tera.project.metaResult.userChange = "";
			console.log(
				"Here",
				this.$tera.project.metaResult.locked,
				this.$tera.project.metaResult.userChange
			);
		}
		this.combinedContent();
	},
	watch: {
		"this.$tera.project.detableStudyCharacteristics": {
			handler(newVal, oldVal) {
				console.log("Detable changed:", newVal, oldVal);
				this.combinedContent();
			},
			deep: true,
			immediate: true
		}
	},
	computed: {
		combinedContent_cal() {
			const fileContent = this.$tera.project.metaReplicant.file || "";
			const rows = this.$tera.project.detableStudyCharacteristics?.rows || [];
			const groupedData = this.groupByHeaders(rows);

			const dynamicContent = this.generateDynamicContent(groupedData);

			const studyCharacteristicsSection = dynamicContent
				? `\n\n<h3>Study Characteristics</h3>\n${dynamicContent}`
				: "";

			return fileContent + studyCharacteristicsSection;
		}
	},
	methods: {
		combinedContent() {
			const fileContent = this.$tera.project.metaReplicant
				? this.$tera.project.metaReplicant.file || ""
				: "";

			// For Study Characteristics Section
			const studyCharacteristics =
				this.$tera.project.detableStudyCharacteristics || {};
			const rows = studyCharacteristics.rows || [];
			const headers = studyCharacteristics.headers || [];

			const transformedRows = rows.map(row => {
				const transformedRow = {};
				headers.forEach(header => {
					// Map the `field` key to the corresponding `headerName`
					const key = header.headerName;
					const value = row[header.field];
					transformedRow[key] = value;
				});
				return transformedRow;
			});
			const groupedData = this.groupByHeaders(transformedRows);
			const dynamicContent = this.generateDynamicContent(groupedData);

			// For Study Characteristics Section
			const studyOutcomes = this.$tera.project.detableSudyOutcome || {};
			const outcomeRows = studyOutcomes.rows || [];
			const outcomeHeaders = studyOutcomes.headers || [];

			const transformedOutcomeRows = outcomeRows.map(row => {
				const transformedOutcomeRow = {};
				outcomeHeaders.forEach(header => {
					// Map the `field` key to the corresponding `headerName`
					const key = header.headerName;
					const value = row[header.field];
					transformedOutcomeRow[key] = value;
				});
				return transformedOutcomeRow;
			});
			const groupedOutcomeData = this.groupByHeaders(transformedOutcomeRows);
			const dynamicOutcomeContent = this.generateDynamicContent(
				groupedOutcomeData
			);

			// Draft Output Section
			const studyCharacteristicsSection = dynamicContent
				? `\n\n<h3>Study Characteristics</h3>\n${dynamicContent}`
				: "";
				// console.log("Here See this-",dynamicOutcomeContent,"-");
				const hasWords = /[a-zA-Z]/.test(dynamicOutcomeContent);
			const studyOutcomeSection = hasWords
				? `\n\n<h3>Study Outcomes</h3>\n${dynamicOutcomeContent}`
				: "";

			// Condition to display Study Characteristics
			this.regeneratedValue = "";
			if (this.$tera.project.writeStudyCharacteristicsOnResultsSection && this.$tera.project.writeStudyOutcomesOnResultsSection) {
				this.regeneratedValue =
					fileContent +
					"" +
					studyCharacteristicsSection +
					"" +
					studyOutcomeSection;
			} 
			else if(this.$tera.project.writeStudyCharacteristicsOnResultsSection) {
				this.regeneratedValue =
					fileContent +
					"" +
					studyCharacteristicsSection;
					
			}
			else if (this.$tera.project.writeStudyOutcomesOnResultsSection) {
				this.regeneratedValue =
					fileContent +
					"" +
					studyOutcomeSection;
			}
			else {
				this.regeneratedValue = fileContent;
			}

			// Condition for Lock and Unlock
			if (!this.$tera.project.metaResult.locked) {
				this.$tera.project.metaResult.userChange = this.regeneratedValue.replace(
					/(\.)(\s*)<h3>/g,
					"$1<br><br><h3>"
				);
			} else if (
				this.$tera.project.metaResult.locked &&
				this.$tera.project.metaResult.userChange == ""
			) {
				this.$tera.project.metaResult.userChange = this.regeneratedValue;
			} else {
				const updateChangeStyle = this.$tera.project.metaResult.userChange;
				this.$tera.project.metaResult.userChange = updateChangeStyle
					.replace(/(\.)(\s*)<h3>/g, "$1<br><br><h3>")
					.replace(/<p><br><\/p>(\s*)<h3>/g, "<br><h3>");
			}
		},
		buttonClick() {
			console.log(
				JSON.stringify(this.$tera.project.detableStudyCharacteristics)
			);
		},
		refresh() {
			// window.location.reload();
			// this.combinedContent();
			console.log(this.$tera.project.metaResult.userChange);
		},
		groupByHeaders(rows) {
			const grouped = {};
			rows.forEach(row => {
				Object.keys(row).forEach(key => {
					if (!grouped[key]) grouped[key] = [];
					grouped[key].push(row[key]);
				});
			});
			return grouped;
		},
		generateDynamicContent(groupedData) {
			console.log("Check for Groped Data", groupedData);
			const templates = this.translations.templates;
			//normalize values (e.g. : '900Ml', '900 ml' -> '900 ml')
			function normalizeValue(value) {
				if (!value) return "";
				const match = value.match(/^(\d+\.?\d*)\s*(\w*)$/i);
				if (match) {
					const numberPart = match[1];
					const unitPart = match[2].toLowerCase();
					return `${numberPart} ${unitPart}`;
				}
				return value;
			}
			// function handling Other keys-user added using Other button
			function handleDynamicKey(key, values) {
				const normalizedValues = values.map(normalizeValue);
				const valueCounts = {};
				normalizedValues.forEach(
					value => (valueCounts[value] = (valueCounts[value] || 0) + 1)
				);
				const entries = Object.entries(valueCounts);

				return entries
					.map(([value, count]) => {
						if (value) {
							if (count > 1) {
								return `In ${count} studies the ${key} was ${value}.`;
							} else {
								return `In 1 study the ${key} was ${value}.`;
							}
						}
					})
					.join(" ");
			}

			// Handling 'Placebo', 'Sham device', 'Usual care', 'No treatment'
			function handleComparisons(groupedData) {
				const comparisonKeys = [
					"Placebo",
					"Sham device",
					"Usual care",
					"No treatment"
				];
				const filteredValues = comparisonKeys
					.filter(
						key => groupedData[key] && groupedData[key].some(value => value)
					)
					.map(key => key);

				if (filteredValues.length === 0) return "";
				if (filteredValues.length === 1) {
					return `The comparison was ${filteredValues[0]}.`;
				}
				const allButLast = filteredValues.slice(0, -1).join(", ");
				const lastItem = filteredValues[filteredValues.length - 1];
				return `The comparisons were ${allButLast} or ${lastItem}.`;
			}

			// let content = Object.keys(groupedData).map(key => {
			// 	const values = groupedData[key];
			// 	if (templates[key] === "NA" || values.length === 0) {
			// 		return '';
			// 	}
			const knownKeysOrder = [
				"Year",
				"Country",
				"Number of participants",
				"Age"
			];
			const groupedDataKeys = Object.keys(groupedData);
			const orderedKeys = knownKeysOrder.concat(
				groupedDataKeys.filter(key => !knownKeysOrder.includes(key))
			);

			let content =
				orderedKeys
					.map(key => {
						if (groupedData[key] && groupedData[key].length > 0) {
							const values = groupedData[key];
							if (templates[key] === "NA" || values.length === 0) {
								return "";
							}
							switch (key) {
								case "Year": {
									const uniqueValues = [...new Set(values)].filter(Boolean);
									if (uniqueValues.length === 1) {
										return templates[key][1].replace(
											"{{year}}",
											uniqueValues[0]
										);
									}
									const startYear = Math.min(...uniqueValues.map(Number));
									const endYear = Math.max(...uniqueValues.map(Number));
									return templates[key][0]
										.replace("{{startYear}}", startYear)
										.replace("{{endYear}}", endYear);
								}

								case "Education level":
								case "Duration of follow-up": {
									const filteredValues = values
										.filter(x => x != "" && !isNaN(Number(x)))
										.map(Number);

									if (filteredValues.length === 0) {
										break;
									}
									const minDuration = Math.min(...filteredValues);
									const maxDuration = Math.max(...filteredValues);
									if (filteredValues.length === 1) {
										return templates[key][1].replace(
											"{{minDuration}}",
											minDuration
										);
									} else {
										return templates[key][0]
											.replace("{{minDuration}}", minDuration)
											.replace("{{maxDuration}}", maxDuration)
											.replace("{{studyCount}}", filteredValues.length);
									}
									// const minDuration = Math.min(...values.filter(x => x != '').map(Number));
									// const maxDuration = Math.max(...values.map(Number));
									// console.log("Education", minDuration, maxDuration)
									// return templates[key][0]
									// 	.replace('{{minDuration}}', minDuration)
									// 	.replace('{{maxDuration}}', maxDuration)
									// 	.replace('{{studyCount}}', values.length);
								}

								// Old Code for Age that looks only individual numbers like 18, 5, 7,30 etc
								case "Age1": {
									const filteredValues = values
										.filter(x => x != "" && !isNaN(Number(x)))
										.map(Number);

									if (filteredValues.length === 0) {
										break;
									}
									const minAge = Math.min(...filteredValues);
									const maxAge = Math.max(...filteredValues);
									console.log("Age change", minAge, maxAge);
									return templates[key][0]
										.replace("{{minAge}}", minAge)
										.replace("{{maxAge}}", maxAge)
										.replace("{{studyCount}}", filteredValues.length);
									// const minAge = Math.min(...values.filter(x => x != '').map(Number));
									// const maxAge = Math.max(...values.map(Number));
									// return templates[key][0]
									// 	.replace('{{minAge}}', minAge)
									// 	.replace('{{maxAge}}', maxAge)
									// 	.replace('{{studyCount}}', values.length);
								}

								// New code that deals with individual numbers ans well as age range like 18, 18-20, 30 etc and empty fields
								case "Age": {
									console.log("Age Data");

									// Regex to find ranges like "18-60" or "18 to 60"
									const agePatterns = /(\d+)\s*-\s*(\d+)|(\d+)\s+to\s+(\d+)/;
									const ageCounts = {};
									let singleAges = [];

									// Filter out empty or invalid entries
									const validValues = values.filter(
										value =>
											value !== "" && value !== null && value !== undefined
									);
									if (validValues.length === 0) {
										return "";
									}

									validValues.forEach(value => {
										const match = value.match(agePatterns);
										if (match) {
											const min = Number(match[1] || match[3]);
											const max = Number(match[2] || match[4]);
											const range = `${min}-${max}`;
											ageCounts[range] = (ageCounts[range] || 0) + 1;
										} else if (!isNaN(Number(value))) {
											// Single age value
											const age = Number(value);
											singleAges.push(age);
										}
									});

									if (
										Object.keys(ageCounts).length === 0 &&
										singleAges.length === 1
									) {
										return templates["Age"][1].replace(
											"{{minAge}}",
											singleAges[0]
										);
									} else if (
										Object.keys(ageCounts).length === 0 &&
										singleAges.length > 1
									) {
										const minAge = Math.min(...singleAges);
										const maxAge = Math.max(...singleAges);
										return templates["Age"][0]
											.replace("{{minAge}}", minAge)
											.replace("{{maxAge}}", maxAge);
									} else {
										// Mix of individual values and ranges or multiple same range
										let output = [];
										for (const [range, count] of Object.entries(ageCounts)) {
											const template =
												count === 1 ? templates["Age"][3] : templates["Age"][2];
											output.push(
												template
													.replace("{{count}}", count)
													.replace("{{range}}", range)
											);
										}
										// single ages mixed with ranges as individual entries
										singleAges.forEach(age => {
											output.push(
												templates["Age"][3]
													.replace("{{count}}", 1)
													.replace("{{range}}", age)
											);
										});
										return output.join(". ");
									}
								}

								case "Number of participants": {
									const filteredValues = values
										.filter(x => x != "" && !isNaN(Number(x)))
										.map(Number);

									if (filteredValues.length === 0) {
										break;
									}
									const minParticipants = Math.min(...filteredValues);
									const maxParticipants = Math.max(...filteredValues);
									return templates[key][0]
										.replace("{{minParticipants}}", minParticipants)
										.replace("{{maxParticipants}}", maxParticipants)
										.replace("{{studyCount}}", filteredValues.length);
									// const minParticipants = Math.min(...values.filter(x => x != '').map(Number));
									// const maxParticipants = Math.max(...values.map(Number));
									// return templates[key][0]
									// 	.replace('{{minParticipants}}', minParticipants)
									// 	.replace('{{maxParticipants}}', maxParticipants)
									// 	.replace('{{studyCount}}', values.length);
								}

								case "Country":
								case "Study design":
								case "Setting": {
									const Counts = {};
									values.forEach(
										value => (Counts[value] = (Counts[value] || 0) + 1)
									);
									const sentences = Object.entries(Counts)
										.map(([list, count]) => {
											if (list) {
												if (count > 1) {
													return templates[key][0]
														.replace("{{count}}", count)
														.replace("{{list}}", list);
												} else {
													return templates[key][1].replace("{{list}}", list);
												}
											}
										})
										.filter(Boolean);

									if (sentences.length > 1) {
										const lastSentence = sentences.pop();
										return sentences.join(", ") + " and " + lastSentence + ".";
									}
									if (sentences.length == 0) {
										break;
									}
									return sentences[0] + ".";
								}

								case "Type of intervention": {
									const interventionCounts = {};
									values.forEach(
										value =>
											(interventionCounts[value] =
												(interventionCounts[value] || 0) + 1)
									);
									return (
										Object.entries(interventionCounts)
											.map(([intervention, count]) => {
												if (intervention) {
													if (count > 1) {
														return `${count} studies looked at ${intervention}`;
													} else {
														return `1 study looked at ${intervention}`;
													}
												}
											})
											.join(", ") + "."
									);
								}

								case "Whether currently pregnant":
								case "Smoker": {
									const valueCounts = { yes: 0, no: 0 };
									values.forEach(value => {
										if (value.toLowerCase() === "yes") {
											valueCounts.yes += 1;
										} else if (value.toLowerCase() === "no") {
											valueCounts.no += 1;
										}
									});
									const sentences = [];
									if (valueCounts["yes"] > 0) {
										if (valueCounts["yes"] === 1) {
											sentences.push(
												templates[key][0].replace(
													"{{count}}",
													valueCounts["yes"]
												)
											);
										} else {
											sentences.push(
												templates[key][1].replace(
													"{{count}}",
													valueCounts["yes"]
												)
											);
										}
									}
									if (valueCounts["no"] > 0) {
										if (valueCounts["no"] === 1) {
											sentences.push(
												templates[key][2].replace(
													"{{count}}",
													valueCounts["no"]
												)
											);
										} else {
											sentences.push(
												templates[key][3].replace(
													"{{count}}",
													valueCounts["no"]
												)
											);
										}
									}
									if (sentences.length == 0) {
										break;
									}
									return sentences.join(". ");
								}
								case "Countryq": {
									console.log("check for value", values);
									break;
								}
								case "Dose":
								case "Dose(I)":
								case "Frequency":
								case "Frequency(I)":
								case "Method of delivery":
								case "Method of delivery(I)":
								case "Who provided the intervention":
								case "Who provided the intervention(I)":
								case "How the intervention was provided":
								case "How the intervention was provided(I)": {
									const normalizedValues = values.map(normalizeValue);
									const valueCounts = {};
									normalizedValues.forEach(
										value =>
											(valueCounts[value] = (valueCounts[value] || 0) + 1)
									);
									const entries = Object.entries(valueCounts);

									const sentences = entries
										.map(([list, count]) => {
											if (list) {
												if (count > 1) {
													return templates[key][0]
														.replace("{{count}}", count)
														.replace("{{list}}", list);
												} else {
													return templates[key][1]
														.replace("{{count}}", count)
														.replace("{{list}}", list);
												}
											}
										})
										.filter(Boolean);
									// console.log("Doseeee", sentences);
									if (sentences.length == 0) {
										break;
									}
									if (sentences.length > 1) {
										const lastSentence = sentences.pop();
										return sentences.join(", ") + " and " + lastSentence + ".";
									}
									// key + "---" +
									return sentences[0] + ".";
								}
								// {
								// 	return handleDynamicKey(key, values);
								// }

								case "Placebo":
								case "Sham device":
								case "Usual care":
								case "No treatment": {
									// return handleComparisons(groupedData);
									break;
								}
								case "Gender": {
									const genderCounts = {
										male: 0,
										female: 0,
										both: 0,
										percentages: {}
									};

									values.forEach(value => {
										const lowerCaseValue = value.toLowerCase();
										if (lowerCaseValue.includes("%")) {
											if (!genderCounts.percentages[value]) {
												genderCounts.percentages[value] = 0;
											}
											genderCounts.percentages[value] += 1;
										} else if (
											lowerCaseValue === "male/female" ||
											lowerCaseValue === "male and female" ||
											lowerCaseValue == "both"
										) {
											// console.log("allllllllll",value,lowerCaseValue)
											genderCounts.both += 1;
										} else if (lowerCaseValue == "male") {
											genderCounts.male += 1;
										} else if (lowerCaseValue == "female") {
											genderCounts.female += 1;
										}
									});

									const sentences = [];

									const percentageSentences = Object.entries(
										genderCounts.percentages
									).map(([percent, count]) => {
										return `${count} stud${
											count > 1 ? "ies" : "y"
										} had ${percent}`;
									});
									if (percentageSentences.length > 0) {
										sentences.push(percentageSentences.join(", "));
									}

									if (genderCounts.male > 0) {
										sentences.push(
											`${genderCounts.male} stud${
												genderCounts.male > 1 ? "ies" : "y"
											} included males`
										);
									}

									if (genderCounts.female > 0) {
										sentences.push(
											`${genderCounts.female} stud${
												genderCounts.female > 1 ? "ies" : "y"
											} included females`
										);
									}

									if (genderCounts.both > 0) {
										sentences.push(
											`${genderCounts.both} stud${
												genderCounts.both > 1 ? "ies" : "y"
											} included both males and females`
										);
									}

									return sentences.join(", ") + ".";
								}
								default: {
									return handleDynamicKey(key, values);
								}
							}
						}
						return "";
					})
					.filter(Boolean)
					.join(". ") + ".";
			const comparisonSentence = handleComparisons(groupedData);
			// console.log('hereeeeeeeeeee', comparisonSentence + content)
			if (comparisonSentence) {
				content = content + " " + comparisonSentence;
			}
			// return content;
			return content
				.replace(/ \./g, ".")
				.replace(/\.\./g, ".")
				.replace(/,\./g, ".")
				.replace(/ ,/g, ",")
				.replace(/\.\./g, ".")
				.replace(/\.\./g, ".");
		},
		onLockChange() {
			// console.log('Clicked Lock',this.$tera.project.metaResult.locked)
			if (this.$tera.project.metaResult.locked) {
				this.confirmDialogVisible = true;
			} else {
				this.$tera.project.metaResult.locked = !this.$tera.project.metaResult
					.locked;
			}
		},
		lockChangeConfirmed() {
			console.log(this.$tera.project.metaResult.locked);
			this.$tera.project.metaResult.locked = !this.$tera.project.metaResult
				.locked;
			this.combinedContent();
			this.confirmDialogVisible = false;
		},
		lockChangeCancelled() {
			this.confirmDialogVisible = false;
		}
	}
};
</script>
<style scoped>
.btnStyles {
	cursor: inherit !important;
	background: transparent !important;
	color: red !important;
	width: 43px !important;
	height: 20px !important;
	border-color: transparent !important;
}

.p-dialog-header-icon {
	display: none !important;
}

.divStyle {
	display: flex;
	justify-content: space-around;
	margin-top: 15px;
}
</style>
